import Link from "next/link";

export const CustomLink = ({ ...props }) => {
  return <Link href={props.href}>{props.children}</Link>;
};
